export const addHttpsProtocolIfDoesNotExist = (url: string): string => {
  return url.includes('https://') ? url : `https://${url}`;
};
